<label class="flex items-center space-x-2 cursor-pointer select-none">

  <!-- custom design -->
  <div
    class="w-5 h-5 flex items-center justify-center rounded border transition-colors my-theme-custom-checkbox-color"
    [ngClass]="
      checkStatusIn
        ? 'my-theme-custom-checkbox-color-active'
        : 'bg-white border-gray-300'
    "
    (click)="toggleCheckbox()"
  >
    <svg
      *ngIf="checkStatusIn"
      class="w-3 h-3 text-white"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
    </svg>
  </div>

  <span class="text-gray-700">{{ label }}</span>
</label>
